export default {
  title: {
    id: 'product_warranty_modal_title',
    defaultMessage: 'Warranty and services',
  },
}
